module.exports = __webpack_public_path__ + "static/media/3.d995a565.png";